import { Tooltip } from "antd";
import { formatNutrient, type NutrientType } from "../utils/nutritionFormat.ts";

type Props = {
  readonly value: number | null | undefined;
  readonly type: NutrientType;
  readonly unit: string;
  readonly language: string;
};

export const NutrientValue = ({ value, type, unit, language }: Props) => {
  if (value == null) return "—";
  const display = `${formatNutrient(value, type, language)} ${unit}`;
  const exact = `${new Intl.NumberFormat(language, { maximumFractionDigits: 3 }).format(value)} ${unit}`;
  return (
    <Tooltip destroyOnHidden title={exact}>
      <span>{display}</span>
    </Tooltip>
  );
};
